"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var M = Object.create;
var x = Object.defineProperty;
var $ = Object.getOwnPropertyDescriptor;
var A = Object.getOwnPropertyNames,
    P = Object.getOwnPropertySymbols,
    j = Object.getPrototypeOf,
    _ = Object.prototype.hasOwnProperty,
    H = Object.prototype.propertyIsEnumerable;

var N = function N(e, t) {
  var n = {};

  for (var o in e) {
    _.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  }

  if (e != null && P) {
    var _iterator = _createForOfIteratorHelper(P(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        t.indexOf(o) < 0 && H.call(e, o) && (n[o] = e[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return n;
};

var U = function U(e, t) {
  for (var n in t) {
    x(e, n, {
      get: t[n],
      enumerable: !0
    });
  }
},
    D = function D(e, t, n, o) {
  if (t && _typeof(t) == "object" || typeof t == "function") {
    var _iterator2 = _createForOfIteratorHelper(A(t)),
        _step2;

    try {
      var _loop = function _loop() {
        var r = _step2.value;
        !_.call(e, r) && r !== n && x(e, r, {
          get: function get() {
            return t[r];
          },
          enumerable: !(o = $(t, r)) || o.enumerable
        });
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return e;
};

var K = function K(e, t, n) {
  return n = e != null ? M(j(e)) : {}, D(t || !e || !e.__esModule ? x(n, "default", {
    value: e,
    enumerable: !0
  }) : n, e);
},
    I = function I(e) {
  return D(x({}, "__esModule", {
    value: !0
  }), e);
};

var Re = {};
U(Re, {
  assignRef: function assignRef() {
    return L;
  },
  canUseDOM: function canUseDOM() {
    return s;
  },
  cloneValidElement: function cloneValidElement() {
    return X;
  },
  composeEventHandlers: function composeEventHandlers() {
    return Y;
  },
  createContext: function createContext() {
    return Z;
  },
  createNamedContext: function createNamedContext() {
    return Q;
  },
  getComputedStyle: function getComputedStyle() {
    return J;
  },
  getComputedStyles: function getComputedStyles() {
    return k;
  },
  getDocumentDimensions: function getDocumentDimensions() {
    return te;
  },
  getOwnerDocument: function getOwnerDocument() {
    return E;
  },
  getOwnerWindow: function getOwnerWindow() {
    return d;
  },
  getScrollPosition: function getScrollPosition() {
    return ne;
  },
  getScrollbarOffset: function getScrollbarOffset() {
    return oe;
  },
  isBoolean: function isBoolean() {
    return z;
  },
  isFunction: function isFunction() {
    return g;
  },
  isNumber: function isNumber() {
    return B;
  },
  isRightClick: function isRightClick() {
    return re;
  },
  isString: function isString() {
    return q;
  },
  makeId: function makeId() {
    return le;
  },
  noop: function noop() {
    return ue;
  },
  useComposedRefs: function useComposedRefs() {
    return G;
  },
  useConstant: function useConstant() {
    return ce;
  },
  useControlledState: function useControlledState() {
    return ae;
  },
  useControlledSwitchWarning: function useControlledSwitchWarning() {
    return ee;
  },
  useEventListener: function useEventListener() {
    return ie;
  },
  useFocusChange: function useFocusChange() {
    return fe;
  },
  useForceUpdate: function useForceUpdate() {
    return se;
  },
  useIsomorphicLayoutEffect: function useIsomorphicLayoutEffect() {
    return b;
  },
  useLazyRef: function useLazyRef() {
    return de;
  },
  usePrevious: function usePrevious() {
    return pe;
  },
  useStableCallback: function useStableCallback() {
    return me;
  },
  useStableLayoutCallback: function useStableLayoutCallback() {
    return xe;
  },
  useStatefulRefValue: function useStatefulRefValue() {
    return ye;
  },
  useUpdateEffect: function useUpdateEffect() {
    return Ee;
  }
});
module.exports = I(Re);

function s() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}

var y = require("react");

function X(e, t) {
  for (var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    n[_key - 2] = arguments[_key];
  }

  return (0, y.isValidElement)(e) ? (0, y.cloneElement).apply(void 0, [e, t].concat(n)) : e;
}

function Y(e, t) {
  return function (n) {
    if (e && e(n), !n.defaultPrevented) return t(n);
  };
}

var W = require("react");

function z(e) {
  return typeof e == "boolean";
}

function g(e) {
  return !!(e && {}.toString.call(e) == "[object Function]");
}

function B(e) {
  return typeof e == "number" && !isNaN(e);
}

function q(e) {
  return typeof e == "string";
}

function L(e, t) {
  if (e != null) if (g(e)) e(t);else try {
    e.current = t;
  } catch (n) {
    throw new Error("Cannot assign value \"".concat(t, "\" to ref \"").concat(e, "\""));
  }
}

function G() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }

  return (0, W.useCallback)(function (t) {
    var _iterator3 = _createForOfIteratorHelper(e),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var n = _step3.value;
        L(n, t);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }, e);
}

function E(e) {
  return s() ? e ? e.ownerDocument : document : null;
}

function d(e) {
  var t = E(e);
  return t ? t.defaultView || window : null;
}

function k(e) {
  var t = d(e);
  return t ? t.getComputedStyle(e, null) : null;
}

function J(e, t) {
  var n;
  return ((n = k(e)) == null ? void 0 : n.getPropertyValue(t)) || null;
}

var c = K(require("react"));

function Q(e, t) {
  var n = c.createContext(t);
  return n.displayName = e, n;
}

function Z(e, t) {
  var n = c.createContext(t);

  function o(l) {
    var S = l,
        u = S.children,
        f = N(S, ["children"]),
        m = c.useMemo(function () {
      return f;
    }, Object.values(f));
    return c.createElement(n.Provider, {
      value: m
    }, u);
  }

  function r(l) {
    var u = c.useContext(n);
    if (u) return u;
    if (t) return t;
    throw Error("".concat(l, " must be rendered inside of a ").concat(e, " component."));
  }

  return n.displayName = "".concat(e, "Context"), o.displayName = "".concat(e, "Provider"), [o, r];
}

var De = require("react");

function ee(e, t, n) {}

function te(e) {
  var o, r;
  var t = E(e),
      n = t.defaultView || window;
  return t ? {
    width: (o = t.documentElement.clientWidth) != null ? o : n.innerWidth,
    height: (r = t.documentElement.clientHeight) != null ? r : n.innerHeight
  } : {
    width: 0,
    height: 0
  };
}

function ne(e) {
  var t = d(e);
  return t ? {
    scrollX: t.scrollX,
    scrollY: t.scrollY
  } : {
    scrollX: 0,
    scrollY: 0
  };
}

function oe() {
  try {
    if (window.innerWidth > document.documentElement.clientWidth) return window.innerWidth - document.documentElement.clientWidth;
  } catch (e) {}

  return 0;
}

function re(e) {
  return "which" in e ? e.which === 3 : "button" in e ? e.button === 2 : !1;
}

function le() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  return e.filter(function (t) {
    return t != null;
  }).join("--");
}

function ue() {}

var F = require("react");

function ce(e) {
  var t = (0, F.useRef)();
  return t.current || (t.current = {
    v: e()
  }), t.current.v;
}

var a = require("react");

function ae(_ref) {
  var e = _ref.controlledValue,
      t = _ref.defaultValue,
      _ref$calledFrom = _ref.calledFrom,
      n = _ref$calledFrom === void 0 ? "A component" : _ref$calledFrom;

  var r = (0, a.useRef)(e !== void 0),
      _ref2 = (0, a.useState)(r.current ? e : t),
      _ref3 = _slicedToArray(_ref2, 2),
      l = _ref3[0],
      u = _ref3[1],
      f = (0, a.useCallback)(function (m) {
    r.current || u(m);
  }, []);

  return [r.current ? e : l, f];
}

var p = require("react");

function ie(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  var o = (0, p.useRef)(t);
  (0, p.useEffect)(function () {
    o.current = t;
  }, [t]), (0, p.useEffect)(function () {
    if (!(n && n.addEventListener)) return;

    function l(u) {
      o.current(u);
    }

    return n.addEventListener(e, l), function () {
      n.removeEventListener(e, l);
    };
  }, [e, n]);
}

var R = require("react");

function fe() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console.log;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "focus";
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  var o = (0, R.useRef)(n.activeElement);
  (0, R.useEffect)(function () {
    o.current = n.activeElement;

    function r(l) {
      o.current !== n.activeElement && (e(n.activeElement, o.current, l), o.current = n.activeElement);
    }

    return n.addEventListener(t, r, !0), function () {
      n.removeEventListener(t, r);
    };
  }, [t, e, n]);
}

var C = require("react");

function se() {
  var _ref4 = (0, C.useState)(Object.create(null)),
      _ref5 = _slicedToArray(_ref4, 2),
      e = _ref5[1];

  return (0, C.useCallback)(function () {
    e(Object.create(null));
  }, []);
}

var v = require("react");

var b = s() ? v.useLayoutEffect : v.useEffect;

var V = require("react");

function de(e) {
  var t = (0, V.useRef)(!1),
      n = (0, V.useRef)();
  return t.current || (t.current = !0, n.current = e()), n;
}

var h = require("react");

function pe(e) {
  var t = (0, h.useRef)(null);
  return (0, h.useEffect)(function () {
    t.current = e;
  }, [e]), t.current;
}

var i = require("react");

function O(e, t) {
  var n = (0, i.useRef)(t);
  return e(function () {
    n.current = t;
  }), (0, i.useCallback)(function () {
    n.current && n.current.apply(n, arguments);
  }, []);
}

function me(e) {
  return O(i.useEffect, e);
}

function xe(e) {
  return O(b, e);
}

var T = require("react");

function ye(e, t) {
  var _ref6 = (0, T.useState)(t),
      _ref7 = _slicedToArray(_ref6, 2),
      n = _ref7[0],
      o = _ref7[1],
      r = (0, T.useCallback)(function (l) {
    e.current = l, o(l);
  }, []);

  return [n, r];
}

var w = require("react");

function Ee(e, t) {
  var n = (0, w.useRef)(!1);
  (0, w.useEffect)(function () {
    n.current ? e() : n.current = !0;
  }, t);
}

0 && (module.exports = {
  assignRef: assignRef,
  canUseDOM: canUseDOM,
  cloneValidElement: cloneValidElement,
  composeEventHandlers: composeEventHandlers,
  createContext: createContext,
  createNamedContext: createNamedContext,
  getComputedStyle: getComputedStyle,
  getComputedStyles: getComputedStyles,
  getDocumentDimensions: getDocumentDimensions,
  getOwnerDocument: getOwnerDocument,
  getOwnerWindow: getOwnerWindow,
  getScrollPosition: getScrollPosition,
  getScrollbarOffset: getScrollbarOffset,
  isBoolean: isBoolean,
  isFunction: isFunction,
  isNumber: isNumber,
  isRightClick: isRightClick,
  isString: isString,
  makeId: makeId,
  noop: noop,
  useComposedRefs: useComposedRefs,
  useConstant: useConstant,
  useControlledState: useControlledState,
  useControlledSwitchWarning: useControlledSwitchWarning,
  useEventListener: useEventListener,
  useFocusChange: useFocusChange,
  useForceUpdate: useForceUpdate,
  useIsomorphicLayoutEffect: useIsomorphicLayoutEffect,
  useLazyRef: useLazyRef,
  usePrevious: usePrevious,
  useStableCallback: useStableCallback,
  useStableLayoutCallback: useStableLayoutCallback,
  useStatefulRefValue: useStatefulRefValue,
  useUpdateEffect: useUpdateEffect
});